/* Ficha: barra de progreso de la galería, alto de la columna de compra y salto a #packs. Sin él la ficha funciona (la columna no se clava). */
(() => {
  const list = document.querySelector('.ficha-product .product__media-list');
  const bar = document.querySelector('.ficha-progress');
  if (list && bar) {
    const fill = () => {
      bar.style.setProperty('--p', (((list.scrollLeft + list.clientWidth) / list.scrollWidth) * 100).toFixed(2) + '%');
      bar.hidden = list.scrollWidth <= list.clientWidth + 1; // una sola foto, o apiladas (desde 990 px)
    };
    list.addEventListener('scroll', fill, { passive: true });
    addEventListener('resize', fill);
    // Al cambiar de color la galería cambia de fotos (ficha-galeria-color) sin desplazarse siempre: se vuelve a medir
    if ('MutationObserver' in window) new MutationObserver(fill).observe(list, { childList: true });
    fill();
  }
  // --col-h: el CSS decide con él dónde se clava la columna (por arriba si cabe, por abajo si es más alta que la ventana).
  // data-col-top: si del título al botón de compra cabe bajo la cabecera (cabecera + 24 + T + 16 <= alto de la ventana, con T = del borde
  // superior de la columna al borde inferior del botón), se clava por arriba aunque sea más alta que la ventana. Se revisa al cambiar el
  // alto de la columna (por ejemplo, al abrir un desplegable: van bajo el botón, así que cambian --col-h pero no T) o el de la ventana.
  const col = document.querySelector('.ficha-col');
  if (col && 'ResizeObserver' in window) {
    const buy = col.querySelector('[data-pack-buy-main]');
    const head = document.querySelector('.lp-header');
    const fit = () => {
      col.style.setProperty('--col-h', col.offsetHeight + 'px');
      const reach = buy ? buy.getBoundingClientRect().bottom - col.getBoundingClientRect().top : Infinity;
      const need = (head ? head.getBoundingClientRect().height : 0) + 24 + reach + 16;
      col.toggleAttribute('data-col-top', need <= document.documentElement.clientHeight);
    };
    new ResizeObserver(fit).observe(col);
    addEventListener('resize', fit);
  }
  // Con la columna clavada, el navegador cuenta con la posición clavada de #packs (puede quedar sobre la ventana): se usa la natural
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="#packs"]');
    const packs = document.getElementById('packs');
    if (!link || !packs || !col || getComputedStyle(col).position !== 'sticky' || link.pathname !== location.pathname) return;
    e.preventDefault();
    const natural = col.parentElement.getBoundingClientRect().top + scrollY + packs.getBoundingClientRect().top - col.getBoundingClientRect().top;
    scrollTo(0, Math.max(0, natural - parseFloat(getComputedStyle(packs).scrollMarginTop)));
    history.pushState(null, '', '#packs');
  });
})();
